import React, { useEffect } from 'react';
import failSoundFile from './fail.wav';
import successSoundFile from './success.wav';

interface Props {
  onScanCode: (code: string) => void;
}

declare global {
  interface Window {
    NativeCall?: (command: string, arg: unknown, callback: null) => void;
    BarcodeData?: (code: string) => void;
  }
}

class DeviceBarcode {
  private successSound = new Audio(successSoundFile);
  private failSound = new Audio(failSoundFile);

  get available(): boolean {
    return 'NativeCall' in window;
  }

  start(): void {
    this.call('scanner.startScan');
  }

  stop(): void {
    this.call('scanner.stopScan');
  }

  async beep(type: 'success' | 'fail'): Promise<void> {
    if (type === 'success') {
      this.successSound?.play();
    } else {
      this.failSound?.play();
      this.call('notify.vibrate');
    }
  }

  private call(command: string, arg: unknown = null): void {
    window.NativeCall?.(command, arg, null);
  }
}

export const deviceBarcodeReader = new DeviceBarcode();

export function DeviceBarcodeReader({ onScanCode }: Props): JSX.Element {
  useEffect(() => {
    window.BarcodeData = (code: string) => {
      onScanCode(code);
    };
  });

  return <></>;
}
